import footerBg from "../images/footerbg.png";
import footerBgAvif from "../images/footerbg.avif";

export const BackgroundSection = () => {

    return <section
        className="position-relative m-0 background-section w-100"
        style={{
            // paddingBottom: "10rem",
        }}
    >
        <picture  >
            <source srcSet={footerBgAvif} type="image/avif" />
            <img
                src={footerBg}
                loading="lazy"
            />
        </picture>
    </section>
}